// Memorial entry for Oz Daniel
import ozDanielPortrait from '../../../images/oz-daniel.jpg';

export const ozDanielMemorial = {
  id: 41,
  name: 'Sgt. Oz Daniel',
  images: {
    portrait: ozDanielPortrait
  },
  info: `
"I'll resist, I won't let them take me." - Oz to his mother before his service

# Sergeant Oz Daniel

![Oz Daniel](${ozDanielPortrait})
*Sergeant Major Oz Daniel, 19, guitarist who kept his promise*

## Everyone's Best Friend

Oz Daniel received his first guitar in third grade and never stopped playing. He dreamed of an international music career and idolized Guns N' Roses. Though eligible for a non-combat role as an outstanding musician, Oz chose tank service. "The guitar could wait."

Born in Beersheba as a twin with sister Hadar, he grew up in Kfar Saba. His mother: "He was perfect in my eyes. Handsome, kind, a boy full of love, joy and gratitude."

He was everyone's best friend - the one who made everyone laugh.

## October 7, 2023

Oz was in one of only six tanks near the Gaza border when Hamas attacked. Tank Crew 3 rushed toward the terrorists with almost no ammunition. Their brakes locked. They were immobilized by RPG fire.

Oz emerged from the disabled tank alive. Rather than surrender, he fought to the end. Footage showed him trying to steal a grenade from a terrorist. He was shot.

Before his service, he told his mother: "I'll resist, I won't let them take me." He kept his promise.

## Coming Home

For 141 days, his family didn't know his fate. On February 25, 2024, the IDF declared him fallen.

His remains returned November 2, 2025. His twin Hadar: "I always made sure to emphasize I'm the older one by 12 minutes. I'll probably keep saying it until my last day."

*He believed in the power of music to change the world. May his memory be a blessing.*

[Read more](https://www.timesofisrael.com/sgt-oz-daniel-19-talented-guitarist-was-a-boy-of-integrity/)
`
};
